import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'minuteSeconds'
})
export class MinuteSecondsPipe implements PipeTransform {

  transform(value: number | null, transformToHours: boolean = false): string | null {
    if (value == null)
      return null;
    if (value < 0)
      throw new RangeError('Invalid argument value. Must be 0 or positive number.');

    const minutes: number = Math.floor(value / 60);
    const seconds = (value - minutes * 60).toString().padStart(2, '0');
    const hours: number = Math.floor(minutes / 60);
    if (!transformToHours) {
      return minutes + ':' + seconds;
    } else {
      return hours + ':' + (minutes - hours * 60).toString().padStart(2, '0') + ':' + seconds;
    }
  }

}
